import { ICondition, IDataGridColumn, IExpression, ISortingOrder } from "./IDataGridProps";
import { v4 as uuid } from "uuid";
import { Worksheet } from "exceljs";
import moment from "moment";
export const IniColumn = (column: IDataGridColumn): IDataGridColumn => {
  let result = {
    ...column,
    isVisible: column.isVisible !== undefined ? column.isVisible : true,
    uuid: uuid(),
    // key: column.uuid,
  };
  if (result.columns && result.columns.length > 0) {
    result.columns = result.columns.map((sub) => {
      return IniColumn(sub);
    });
  }
  if (result.columns && result.columns.length > 0) {
    result.width = result.columns
      .filter((x) => x.isVisible === true)
      .map((x: any) => x.width as number)
      .reduce((a: number, b: number) => a + b, 0);
  }
  return result;
};
export const IniColumns = (columns: IDataGridColumn[]): IDataGridColumn[] => {
  const result = columns.map((col) => {
    return IniColumn(col);
  });
  return result;
};

export interface IDataGridHeaderCell extends IDataGridColumn {
  rowspan: number;
  colspan: number;
  level: number;
}

export interface IDataGridHeaderRow {
  rowIdx: number;
  cells: IDataGridHeaderCell[];
}
export const GetDataGridHederGroupCell = (columns: IDataGridColumn[]) => {
  const result = buildHeaderRows(columns);
  return result;
};
export const GetDataGridRowCell = (columns: IDataGridColumn[]) => {
  const result: IDataGridColumn[] = [];
  columns.forEach((column) => {
    SettingDataGridRowCell(column, result);
  });
  let lastFixedLeftIdx = -1;
  for (let i = result.length - 1; i >= 0; i--) {
    if (result[i].id !== "col_idx" && result[i].fixed === "left") {
      lastFixedLeftIdx = i;
      break;
    }
  }
  const lastFixedRightIdx = result.findIndex(
    (x) => x.id !== "selection" && x.fixed === "right",
  );
  if (lastFixedLeftIdx >= 0) result[lastFixedLeftIdx].isLastColFixed = true;
  if (lastFixedRightIdx >= 0) result[lastFixedRightIdx].isLastColFixed = true;
  return result;
};

export const SettingDataGridRowCell = (
  column: IDataGridColumn,
  result: IDataGridColumn[],
) => {
  if (!column.columns || column.columns.length === 0) {
    result.push(column);
  } else {
    column.columns.forEach((sub) => {
      SettingDataGridRowCell(sub, result);
    });
  }
};

const getMaxDepth = (columns: IDataGridColumn[], depth = 1): number => {
  return Math.max(
    ...columns.map((col) =>
      col.columns?.length ? getMaxDepth(col.columns, depth + 1) : depth,
    ),
  );
};
const countLeafColumns = (column: IDataGridColumn): number => {
  if (!column.columns || column.columns.length === 0) {
    return 1;
  }

  return column.columns.reduce((sum, col) => sum + countLeafColumns(col), 0);
};
export function buildHeaderRows(
  columns: IDataGridColumn[],
): IDataGridHeaderRow[] {
  const maxLevel = getMaxDepth(columns);
  const rows: IDataGridHeaderRow[] = [];

  function traverse(cols: IDataGridColumn[], level: number) {
    rows[level - 1] ??= {
      rowIdx: level - 1,
      cells: [],
    };

    cols.forEach((col) => {
      const isGroup = !!col.columns?.length;

      const cell: IDataGridHeaderCell = {
        ...col,
        level,
        colspan: isGroup ? countLeafColumns(col) : 1,
        rowspan: isGroup ? 1 : maxLevel - level + 1,
      };

      rows[level - 1].cells.push(cell);

      if (isGroup) {
        traverse(col.columns!, level + 1);
      }
    });
  }

  traverse(columns, 1);
  return rows;
}
export const removeAccents = (str: string) => {
  if (!str) return str;
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D");
};
const extractTextFromReactNode = (node: any): string => {
  if (node === undefined || node === null || typeof node === "boolean") {
    return "";
  }

  if (typeof node === "string" || typeof node === "number") {
    return String(node);
  }

  if (Array.isArray(node)) {
    return node.map((item) => extractTextFromReactNode(item)).join(" ");
  }

  if (typeof node === "object") {
    if (node.props?.text !== undefined) {
      return extractTextFromReactNode(node.props.text);
    }

    if (node.props?.children !== undefined) {
      return extractTextFromReactNode(node.props.children);
    }
  }

  return "";
};

const getColumnSearchValue = (column: IDataGridColumn, item: any) => {
  if (column.calculateCellValue) {
    return column.calculateCellValue(item);
  }

  if (column.cellRender) {
    const renderedNode = column.cellRender(item);
    const renderedText = extractTextFromReactNode(renderedNode);
    if (renderedText) {
      return renderedText;
    }
  }

  if (column.dataField) {
    return item[column.dataField];
  }

  return undefined;
};

const normalizeSearchText = (value: any): string => {
  if (value === undefined || value === null) return "";

  if (Array.isArray(value)) {
    return value.map((x) => normalizeSearchText(x)).join(" ");
  }

  if (typeof value === "object") {
    return Object.values(value)
      .map((x) => normalizeSearchText(x))
      .join(" ");
  }

  return String(value);
};

export const handleSearchByDataField = (
  columns: IDataGridColumn[],
  data: any[],
  key: string,
): any[] => {
  const normalizedKey = removeAccents(key.toLowerCase());

  return data.filter((item) => {
    const columnBasedText = columns
      .map((column) => getColumnSearchValue(column, item))
      .filter((value) => value !== undefined && value !== null)
      .map((value) => normalizeSearchText(value))
      .join(" ");

    const fullRowText = normalizeSearchText(item);
    const searchableText = columnBasedText || fullRowText;

    return removeAccents(searchableText.toLowerCase()).includes(normalizedKey);
  });
};
export const dynamicSort = (property: string, mode: ISortingOrder) => {
  var sortOrder = 1;
  if (mode === "asc") {
    sortOrder = 1;
  } else {
    sortOrder = -1;
  }
  return function (a: any, b: any) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
};

export const renderExcelHeader = (
  worksheet: Worksheet,
  headerRows: IDataGridHeaderRow[],
  startRow = 1,
  startCol = 1,
) => {
  const occupied = new Map<string, boolean>();

  const isOccupied = (r: number, c: number) =>
    occupied.get(`${r}_${c}`) === true;

  const markOccupied = (r1: number, c1: number, r2: number, c2: number) => {
    for (let r = r1; r <= r2; r++) {
      for (let c = c1; c <= c2; c++) {
        occupied.set(`${r}_${c}`, true);
      }
    }
  };

  headerRows.forEach((headerRow, rowOffset) => {
    const row = startRow + rowOffset;
    let col = startCol;

    headerRow.cells.forEach((cell) => {
      // 🔑 tìm cột trống tiếp theo
      while (isOccupied(row, col)) {
        col++;
      }

      const excelCell = worksheet.getCell(row, col);
      excelCell.value = cell.caption ?? cell.dataField?.toString() ?? "";

      excelCell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };

      excelCell.font = { bold: true };
      excelCell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      const r2 = row + cell.rowspan - 1;
      const c2 = col + cell.colspan - 1;

      if (cell.rowspan > 1 || cell.colspan > 1) {
        worksheet.mergeCells(row, col, r2, c2);
      }

      // 🔑 đánh dấu vùng đã chiếm
      markOccupied(row, col, r2, c2);

      col += cell.colspan;
    });
  });
};

export const handleFilter = (conditions: ICondition[], data: any[], logicOperator: string, columns?: IDataGridColumn[]): any[] => {
  const filterExpression = conditions.map((cond: any) => [cond.field, cond.operator, cond.value])
    .reduce((acc: any, curr: any, i: any) => (i > 0 ? [...acc, logicOperator, curr] : [curr]), []);
  return data.filter((item) => {
    let result = true;
    let currentOperator = "and";

    for (let i = 0; i < filterExpression.length; i++) {
      const expr = filterExpression[i];
      if (typeof expr === "string") {
        currentOperator = expr;
        continue;
      }
      const [field, operator, value]: IExpression = expr;
      const matchedColumn = columns?.find((column) => column.dataField === field);
      const itemValue = matchedColumn ? getColumnSearchValue(matchedColumn, item) : item[field];
      const normalizedItemValue = normalizeSearchText(itemValue);

      let conditionResult;
      switch (operator) {
        case "equals":
          conditionResult = removeAccents(normalizedItemValue.toLowerCase()) === removeAccents(String(value ?? "").toLowerCase());
          break;
        case "contains":
          conditionResult = removeAccents(normalizedItemValue.toLowerCase()).includes(removeAccents(String(value ?? "").toLowerCase()));
          break;
        case "greaterThan":
          conditionResult = Number(itemValue) > Number(value);
          break;
        case "lessThan":
          conditionResult = Number(itemValue) < Number(value);
          break;
        case "greaterThanOrEqual":
          conditionResult = Number(itemValue) >= Number(value);
          break;
        case "lessThanOrEqual":
          conditionResult = Number(itemValue) <= Number(value);
          break;
        case "includes":
          if (!Array.isArray(value)) return false;
          conditionResult = value
            .map((x) => removeAccents(normalizeSearchText(x).toLowerCase()))
            .includes(removeAccents(normalizedItemValue.toLowerCase()));
          break;
        default:
          conditionResult = true;
      }
      result = currentOperator === "and" ? result && conditionResult : result || conditionResult;
    }
    return result;
  });
};
export const formatDisplay = (col: IDataGridColumn, value: any) => {
  // debugger
  if (col.dataType === "number" && (value ?? "") !== "") {
    return new Intl.NumberFormat('vi-VN', {
      // style: 'currency',
      currency: 'VND',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  }
  if (col.dataType === "date" && (value ?? "") !== "") {
    // debugger
    return moment(value).format("DD/MM/YYYY")
  }
  return value;
}